<template>
    <div class="d-flex align-items-center h-100">
        <div v-if="!loading" class="factor-container">
            <b-card no-body>
                <b-card-header
                    :class="transactionDetail.isSuccess == 'True' ? 'bg-success' : 'bg-danger'"></b-card-header>
                <b-card-body class="p-0">
                    <h5 class="px-3 pt-2">
                        {{ transactionDetail.isSuccess == 'True' ? 'تراکنش موفق' : 'تراکنش ناموفق' }}
                    </h5>
                    <hr>
                    <div v-if="transactionDetail.trackingNumber"
                        class="d-flex justify-content-between align-items-center mt-3 px-3 pb-1">
                        <h6>شماره پیگیری</h6>
                        <h6>{{ transactionDetail.trackingNumber }}</h6>
                    </div>
                    <div v-if="transactionDetail.amount"
                        class="d-flex justify-content-between align-items-center mt-1 px-3 pb-2">
                        <h6>مبلغ تراکنش</h6>
                        <div class="d-flex align-items-center">
                            <h6 class="mb-0">{{ transactionDetail.amount.toLocaleString('fa-IR') }}</h6>
                            <span class="ml-25" style="font-size: 12px !important;">ریال</span>
                        </div>
                    </div>
                    <div class="p-2">
                        <b-button v-if="!isChargeSms" @click="$router.push('/transactions')" class="w-100">تاریخچه اشتراک</b-button>
                        <b-button v-else @click="$router.push('/sms-account-report')" class="w-100">تاریخچه شارژ حساب پیامکی</b-button>
                    </div>
                </b-card-body>
            </b-card>
        </div>
    </div>
</template>


<script>
import { BButton, BCard, BCardText, BCardBody, BCardHeader } from 'bootstrap-vue';

export default {
    name: "factor",
    components: {
        BCard,
        BCardText,
        BCardBody,
        BButton,
        BCardHeader
    },
    data() {
        return {
            loading: true,
            transactionDetail: {
                amount: 0,
                trackingNumber: 0,
                isSuccess: false,
                storeSubscriptionId: null,
                isChargeSms: false
            },
        };
    },
    mounted() {
        if (this.$route.query.isSuccess) {
            this.transactionDetail.amount = parseInt(this.$route.query.amount)
            this.transactionDetail.trackingNumber = this.$route.query.trackingNumber
            this.transactionDetail.isSuccess = this.$route.query.isSuccess
            this.transactionDetail.storeSubscriptionId = this.$route.query.storeSubscriptionId
            this.isChargeSms = this.$route.query.isChargeSms
            this.loading = false
        }
        else {
            this.$router.push('/');
        }
    },
};
</script>

<style lang="scss">
.factor-container {
    width: 600px;
    margin: 0 auto;
}
</style>